module.exports = __webpack_public_path__ + "img/todo-list.ed080b7c.svg";